<template>
    <LoadMoreList ref="loadMoreRef" :load-page="props.onWorkLoadPage" v-model:list="remember.list"
                  :load-more-url="props.loadMoreUrl"
                  v-model:page="remember.page">
        <template #no-data>
            <slot name="no-data"></slot>
        </template>
        <template #default="{list}">
            <div class="work-container">
                <div class="work-box">
                    <MasonryLayout :gutter="props.gutter" ref="masLayout" :items="list" :item-width="props.itemWidth">
                        <template #item="{item, index}">
                            <slot name="item" :item="item">
                                <Work :width="props.itemWidth" :not-modal="props.notModal" :item="item"
                                      :show-name="props.showName"></Work>
                            </slot>
                        </template>
                    </MasonryLayout>
                </div>
            </div>
        </template>
    </LoadMoreList>
</template>

<script setup lang="ts">
import {onMounted, ref, watch} from "vue";
import LoadMoreList from "@/Components/Common/LoadMoreList.vue";
import Work from "@/Components/Work/Work.vue";
import {useRemember} from "@inertiajs/vue3";
import MasonryLayout from "@/Components/Common/MasonryLayout.vue";

const isShow = ref(false)
const masLayout = ref()
const loadMoreRef = ref<LoadMoreList>()
const emits = defineEmits(['update:page'])

const props = withDefaults(defineProps<{
    onWorkLoadPage: (page: number) => Promise<any[]>,
    defaultList?: any[],
    defaultPage?: number,
    showName?: boolean,
    notModal?: boolean,
    itemWidth?: string,
    gutter?: string | number,
    page?: number,
    loadMoreUrl?: string,
}>(), {
    defaultList: [] as any,
    defaultPage: 1,
    showName: false,
    notModal: false,
    itemWidth: '316px',
    gutter: '10px',
    page: 1,
})

const remember = useRemember<{
    list: any[],
    page: number,
}>({
    list: props.defaultList,
    page: props.defaultPage,
})

onMounted(() => {
    isShow.value = true
})

watch(()=>remember.page, ()=>{
    emits('update:page', remember.page)
})

defineExpose({
    reload() {
        loadMoreRef.value?.reloadPage()
    }
})


</script>

<style scoped lang="scss">
.work-container {
    padding: 0 100px 0 100px;

    .work-box {
        width: 100%;
        display: flex;
        justify-content: center;

    }

    .no-more {
        width: 100%;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        color: #282828;
    }
}
</style>
